import type { ISocialProfileOption } from "containers/NewBeneficiaryContainer";
import { socialProfileList } from "containers/NewBeneficiaryContainer";
import { forwardRef } from "react";
import type { Control, FieldError, FieldErrorsImpl, Merge } from "react-hook-form";
import { useTranslation } from "react-i18next";

import AutocompleteFormComponent from "../FormComponent/AutocompleteFormComponent";
import type { IRepresentativeFormValues } from "../Representatives/RepresentativeForm";

interface ISocialProfileAutocomplete {
    errors: Merge<FieldError, FieldErrorsImpl<{ type: string; description: string }>> | undefined;
    control: Control<IRepresentativeFormValues>;
    companyDistributorType: number | undefined;
    controlName: string;
    required?: boolean;
    disabled?: boolean;
}

const SocialProfileAutocomplete = forwardRef<HTMLDivElement, ISocialProfileAutocomplete>(
    function SocialProfileAutocomplete(
        { control, errors, companyDistributorType, controlName, required, disabled }: ISocialProfileAutocomplete,
        ref,
    ) {
        const [t] = useTranslation();

        const renderSocialProfileOption = (props: object, option: ISocialProfileOption) => (
            <li {...props} className="social-profile-list">
                <span>{option.type}</span>
                <div className="separator"></div>
                <span>{option.description}</span>
            </li>
        );

        return (
            <AutocompleteFormComponent
                label={`${t("NewBeneficiary.SocialProfile")}`}
                options={socialProfileList[(companyDistributorType ?? 0) - 1]}
                renderOptionText={(option: any) => `${option.type} | ${option.description}`}
                defaultFilterOptions
                control={control}
                renderOption={renderSocialProfileOption}
                controlName={controlName}
                required={required}
                disabled={disabled}
                error={errors}
                customRequiredMessage={t("NewBeneficiary.RequiredSocialProfile")}
                ref={ref}
            />
        );
    },
);

export default SocialProfileAutocomplete;
